import { Information } from '@carbon/icons-react';
import { Typography } from 'antd';
import classNames from 'classnames';

export default function FormHelperText({ text, className, iconProps, textProps }) {
  return (
    <div className={classNames('flex items-top gap-2 mt-2', className)}>
      <Information
        className={classNames('w-4 h-4 mt-[1px] text-gray-500 flex-shrink-0', iconProps?.className)}
        {...iconProps}
      />

      <Typography.Text type="secondary" className={classNames('text-sm', textProps?.className)} {...textProps}>
        {text}
      </Typography.Text>
    </div>
  );
}
